import React from 'react'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import MainImg from '../imgs/projects/redwood1.jpg'

const styles = theme => ({
    container: {
        textAlign: 'center'
    },
    img: {
        width: '100%',
        margin: '30px 0'
    },
    content: {
        color: '#393287',
        width: '80%',
        margin: '0 auto',
        fontFamily: "'Dancing Script', cursive"
    }
})

const Home = ({classes}) => (
    <div className={classes.container}>
        <img className={classes.img} src={MainImg} />
        <Typography className={classes.p} variant="headline" className={classes.content}>
            Our design philosophy is that great design will last forever, and we strive to develop those timeless interiors. Purpleleaf Design works with the client to establish their desires and needs; to create a cohesive, harmonious atmosphere within which to dwell.
        </Typography>
    </div>
)

export default withStyles(styles)(Home)